// Data Storage units data for conversion routes
// Base unit: bit

export const dataStorageUnits = [
  { id: 'bit', name: 'Bit', symbol: 'b', plural: 'Bits', factor: 1 },
  { id: 'byte', name: 'Byte', symbol: 'B', plural: 'Bytes', factor: 8 },
  { id: 'kilobit', name: 'Kilobit', symbol: 'Kb', plural: 'Kilobits', factor: 1000 },
  { id: 'kilobyte', name: 'Kilobyte', symbol: 'KB', plural: 'Kilobytes', factor: 8000 },
  { id: 'megabit', name: 'Megabit', symbol: 'Mb', plural: 'Megabits', factor: 1000000 },
  { id: 'megabyte', name: 'Megabyte', symbol: 'MB', plural: 'Megabytes', factor: 8000000 },
  { id: 'gigabit', name: 'Gigabit', symbol: 'Gb', plural: 'Gigabits', factor: 1000000000 },
  { id: 'gigabyte', name: 'Gigabyte', symbol: 'GB', plural: 'Gigabytes', factor: 8000000000 },
  { id: 'terabit', name: 'Terabit', symbol: 'Tb', plural: 'Terabits', factor: 1000000000000 },
  { id: 'terabyte', name: 'Terabyte', symbol: 'TB', plural: 'Terabytes', factor: 8000000000000 },
  { id: 'petabit', name: 'Petabit', symbol: 'Pb', plural: 'Petabits', factor: 1000000000000000 },
  { id: 'petabyte', name: 'Petabyte', symbol: 'PB', plural: 'Petabytes', factor: 8000000000000000 },
  // Binary units (IEC standard)
  { id: 'kibibyte', name: 'Kibibyte', symbol: 'KiB', plural: 'Kibibytes', factor: 8192 }, // 8 * 1024
  { id: 'mebibyte', name: 'Mebibyte', symbol: 'MiB', plural: 'Mebibytes', factor: 8388608 }, // 8 * 1024^2
  { id: 'gibibyte', name: 'Gibibyte', symbol: 'GiB', plural: 'Gibibytes', factor: 8589934592 }, // 8 * 1024^3
  { id: 'tebibyte', name: 'Tebibyte', symbol: 'TiB', plural: 'Tebibytes', factor: 8796093022208 }, // 8 * 1024^4
  { id: 'pebibyte', name: 'Pebibyte', symbol: 'PiB', plural: 'Pebibytes', factor: 9007199254740992 }, // 8 * 1024^5
];

// Popular conversions matching common usage
export const popularDataStorageConversions = [
  { from: 'gigabyte', to: 'megabyte' },
  { from: 'megabyte', to: 'gigabyte' },
  { from: 'megabyte', to: 'kilobyte' },
  { from: 'kilobyte', to: 'megabyte' },
  { from: 'terabyte', to: 'gigabyte' },
  { from: 'gigabyte', to: 'terabyte' },
  { from: 'byte', to: 'bit' },
  { from: 'bit', to: 'byte' },
  { from: 'kilobyte', to: 'byte' },
  { from: 'byte', to: 'kilobyte' },
  { from: 'megabyte', to: 'byte' },
  { from: 'byte', to: 'megabyte' },
  { from: 'gigabyte', to: 'gibibyte' },
  { from: 'gibibyte', to: 'gigabyte' },
  { from: 'megabyte', to: 'mebibyte' },
  { from: 'mebibyte', to: 'megabyte' },
  { from: 'terabyte', to: 'tebibyte' },
  { from: 'tebibyte', to: 'terabyte' },
  { from: 'megabit', to: 'megabyte' },
  { from: 'megabyte', to: 'megabit' },
  { from: 'gigabit', to: 'gigabyte' },
  { from: 'gigabyte', to: 'gigabit' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return dataStorageUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertDataStorage = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to bits first, then to target unit
  const bits = value * fromUnit.factor;
  return bits / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertDataStorage(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online data storage unit converter.`;
};
